import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    unreadByRequest: {},
    activeRooms: [], // Track rooms that user is actively viewing or should listen to
  },
  reducers: {
    incrementUnread(state, action) {
      const { requestId } = action.payload;
      state.unreadByRequest[requestId] =
        (state.unreadByRequest[requestId] || 0) + 1;
    },
    clearUnread(state, action) {
      const { requestId } = action.payload;
      state.unreadByRequest[requestId] = 0;
    },
    clearAllUnread(state) {
      state.unreadByRequest = {};
    },
    setActiveRoom(state, action) {
      const { roomId } = action.payload;
      if (roomId) {
        state.activeRooms = [roomId];
      }
    },
    removeActiveRoom(state, action) {
      const { roomId } = action.payload;
      state.activeRooms = state.activeRooms.filter((id) => id !== roomId);
    },
  },
});

export const {
  incrementUnread,
  clearUnread,
  clearAllUnread,
  setActiveRoom,
  removeActiveRoom,
} = chatSlice.actions;

export const selectTotalUnread = (state) =>
  Object.values(state.chat.unreadByRequest).reduce((sum, n) => sum + n, 0);

export const selectActiveRooms = (state) => state.chat.activeRooms;

export default chatSlice.reducer;
